import { render, staticRenderFns } from "./SelectMediaPopup.vue?vue&type=template&id=82257804&"
import script from "./SelectMediaPopup.vue?vue&type=script&lang=js&"
export * from "./SelectMediaPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports